// misc js routines

jQuery(document).ready(function ($) {
	$('body').on('click', function (e) {
		const $target = $(e.target);

		const $abbrTooltip = $('.abbr-tooltip');
		$abbrTooltip.remove();

		if ($target.is('abbr') && !hoverAvailable()) {
			const targetOffset = $target.offset();

			const $child = $(
				'<div class="abbr-tooltip">' + $target.attr('title') + '</div>'
			).appendTo($target);

			const childLeft = -(targetOffset.left / 2);

			// Apply the calculated position
			$child.css({
				left: childLeft + 'px',
			});
		}
	});
});

function hoverAvailable() {
	jQuery('body').append('<div id="hover-test" class="supports-hover"></div>');
	const available =
		jQuery('#hover-test').css('position') === 'absolute' &&
		jQuery('#hover-test').css('left') === '-9999px';
	jQuery('#hover-test').remove();
	return available;
}
